import { render, staticRenderFns } from "./FlexDirectionProperty.vue?vue&type=template&id=6ae36501&"
import script from "./FlexDirectionProperty.vue?vue&type=script&lang=js&"
export * from "./FlexDirectionProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports